import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import style from './styles/style.module.css';
import { Field, reduxForm, Form } from 'redux-form';
import { PrimaryButton } from 'appSrc/components/UI';
import { FormTextField } from 'appSrc/components/UI/ReduxForm';

class ProfessionForm extends PureComponent {
    constructor( props ) {
        super( props );
    }
    submit = ( values ) => {
        this.props.next( values );
    }
    render() {
        const { handleSubmit } = this.props;
        return (
            <Form
            className={ style.professionForm }
            onSubmit={ handleSubmit( this.submit ) }>
                <Field
                name="title"
                label="Name"
                component={ FormTextField }
                fullWidth />

                <PrimaryButton
                label="Submit"
                fullWidth
                type="submit"
                style={ { marginTop: '15px' } }/>
            </Form>
        );
    }
}

ProfessionForm = reduxForm( {
    form: 'ProfessionForm',
} )( ProfessionForm );


export default connect()( ProfessionForm );
